module.exports = __webpack_public_path__ + "img/Apoptosis-GBM_GSE194329.da8cec36.png";